import { AxiosResponse } from 'axios';
import requestClient from '../components/Utility/RequestClient';
import {Knowledgebase, KnowledgebaseDocumentStatus, KnowledgebaseFormData} from '../Types';
import Store from '../Store/Store';

const resolveDemo = () => Store.getState().environment.demoInstance;

export const knowledgebaseService = {
    getKnowledgebases: (): Promise<AxiosResponse<Knowledgebase[]>> => {
        return requestClient.get(`${resolveDemo() ? '/demo' : ''}/knowledgebases/get`);
    },

    getKnowledgebasesByPage: (
        page: number,
        itemsPerPage: number,
        optionalParams?: Record<string, any>,
        query?: string | null,
    ): Promise<{ data: { data: Knowledgebase[]; total: number } }> => {
        return requestClient
            .get(`${resolveDemo() ? '/demo' : ''}/knowledgebases/get`, {
                params: {
                    page,
                    itemsPerPage,
                    query,
                },
            })
            .then((response: any) => response);
    },

    getKnowledgebase: (id: string): Promise<AxiosResponse<Knowledgebase>> => {
        return requestClient.get(`${resolveDemo() ? '/demo' : ''}/knowledgebases/get/${id}`);
    },

    getKnowledgebaseDocuments: async (id: string, status: KnowledgebaseDocumentStatus | null, page: number, itemsPerPage: number, query?: string | null): Promise<{ data: { data: Knowledgebase[]; total: number } }> => {
        return requestClient.get(
            `/knowledgebases/get/${id}/documents`,{
                params: {
                    status,
                    page,
                    itemsPerPage,
                    query,
                },
            }
        );
    },

    createKnowledgebase: (data: KnowledgebaseFormData): Promise<AxiosResponse<Knowledgebase>> => {
        const formData = new FormData();
        formData.append('name', data.name || '');
        formData.append('description', data.description || '');

        if (data.documents) {
            data.documents.forEach((file) => {
                formData.append('documents[]', file.sha1);
            });
        }

        return requestClient.post('/knowledgebases/create', formData);
    },

    updateKnowledgebase: (id: string, data: KnowledgebaseFormData): Promise<AxiosResponse<Knowledgebase>> => {
        const formData = new FormData();
        formData.append('name', data.name || '');
        formData.append('description', data.description || '');

        if (data.documents) {
            data.documents.forEach((file) => {
                formData.append('documents[]', file.sha1);
            });
        }

        formData.append('documentsToRemove', JSON.stringify(data.documentsToRemove));
        formData.append('documentsToReembed', JSON.stringify(data.documentsToReembed));

        return requestClient.post(`/knowledgebases/update/${id}`, formData);
    },

    checkDocumentsExistence: (id: string, sha1s: string[]): Promise<AxiosResponse<string[]>> => {
        const formData = new FormData();
        sha1s.forEach((sha1) => {
            formData.append('sha1s[]', sha1);
        });
        return requestClient.post(`/knowledgebases/check-documents-existence/${id}`, formData);
    },

    deleteKnowledgebase: (id: string): Promise<AxiosResponse<void>> => {
        return requestClient.delete(`/knowledgebases/delete/${id}`);
    },

    uploadFile: async (formData: any): Promise<any> => {
        return requestClient.post(`/knowledgebases/uploadfile`, formData);
    },
};
